import { useState, useCallback } from 'react';

export type Mode = 'browse' | 'add' | 'edit';

export function usePWM202Mode() {
  const [mode, setMode] = useState<Mode>('browse');

  const toBrowse = useCallback(() => setMode('browse'), []);
  const toAdd = useCallback(() => setMode('add'), []);
  const toEdit = useCallback(() => setMode('edit'), []);

  const isEditing = mode === 'add' || mode === 'edit';

  return { mode, setMode, toBrowse, toAdd, toEdit, isEditing };
}
